import { Fragment, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    CircularProgress,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Tooltip
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import moment from 'moment';
import { useSwaggerClient } from '../../hooks/useSwaggerClient';
import TablePager from '../atom/TablePager';
import { formatMoney } from '../../utils';
import { PrinterIcon } from '../../icons';

const PaymentsTable = () => {
    const { guestId } = useParams();
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [data, loadingPayments, paymentsError] = useSwaggerClient(
        'users',
        'getPaymentsByUserId',
        {
            userId: Number.isNaN(parseInt(guestId, 10)) ? 'me' : parseInt(guestId, 10),
            page,
            pageSize
        }
    );

    if (paymentsError) {
        return (
            <Grid container>
                <Grid item xs={12}>
                    <Alert severity="error">Could not load payments made by this user.</Alert>
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid container className="mt-2">
            <Grid container alignItems="center">
                <Grid item className="mr-auto" style={{ paddingLeft: '12px' }}>
                    <h2>Payments</h2>
                </Grid>
                <Grid item>
                    {data?.payments?.length > 0 && (
                        <Tooltip
                            title={
                                data?.printUrl
                                    ? 'Print Payments'
                                    : 'No transactions with booking items to print'
                            }
                            interactive
                        >
                            <span style={{ pointerEvents: 'auto' }}>
                                <IconButton
                                    href={`${data?.printUrl}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    disabled={!data?.printUrl}
                                >
                                    <PrinterIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    )}
                </Grid>
            </Grid>
            {loadingPayments ? (
                <Grid item xs={12}>
                    <CircularProgress />
                </Grid>
            ) : (
                <>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Amount</TableCell>
                                    <TableCell>Type</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data?.payments.map(payment => {
                                    const paymentBlocks = [];
                                    if (payment.last4 !== null && payment.lastname !== null) {
                                        paymentBlocks.push(
                                            <Fragment key="card-info">
                                                <b>Card last 4 digit:&nbsp;</b>
                                                {payment.last4}
                                                <br />
                                                <b>Last name:&nbsp;</b>
                                                {payment.lastname}
                                            </Fragment>
                                        );
                                    }
                                    if (payment.agentName !== null) {
                                        paymentBlocks.push(
                                            <Fragment key="agent-info">
                                                <b>By:&nbsp;</b>
                                                {payment.agentName}
                                            </Fragment>
                                        );
                                    }
                                    if (payment.note !== '') {
                                        paymentBlocks.push(
                                            <Fragment key="note-info">
                                                <b>Note:&nbsp;</b>
                                                {payment.note}
                                            </Fragment>
                                        );
                                    }

                                    return (
                                        <Fragment key={payment.id}>
                                            <TableRow>
                                                <TableCell>
                                                    {moment(payment.date).format(
                                                        'ddd. MMM DD, YYYY'
                                                    )}
                                                </TableCell>
                                                <TableCell>{formatMoney(payment.amount)}</TableCell>
                                                <TableCell>{payment.type}</TableCell>
                                            </TableRow>
                                            {paymentBlocks.length > 0 && (
                                                <TableRow>
                                                    <TableCell colSpan={3}>
                                                        <div style={{ paddingLeft: '1.5rem' }}>
                                                            {paymentBlocks.map(oneBlock => {
                                                                return (
                                                                    <div key={oneBlock.key}>
                                                                        {oneBlock}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </Fragment>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePager
                        total={data?.total}
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                    />
                </>
            )}
        </Grid>
    );
};

export default PaymentsTable;
